import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-public-challenge',
  templateUrl: './public-challenge.component.html',
  styleUrls: ['./public-challenge.component.css']
})
export class PublicChallengeComponent {
  knolliUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    const url = environment.KNOLLI_CHAT_URL + '/knolli/1542?' +
      'title=' + encodeURIComponent('Welcome to 10 Days to Close a Tax Plan Challenge - Hosted By Dr Jackie Meyer & TaxPlanIQ') +
      '&subtitle=' + encodeURIComponent('You are a dedicated assistant and coach to guide a tax advisor through closing their first, or just their best, tax planning engagement in the next 2 weeks. ');
    this.knolliUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
